export const DividendWithRtrColumnHeaderMap = {
  PUA: [
    'policyYear',
    'ageEndYear',
    'guaranteedContractPremiumBegYear',
    'guaranteedCashValueEndYear',
    'guaranteedDeathBenefitEndYear',
    'contractPremiumBegYear',
    'annualDividendEndYear',
    'cashValueOfAdditionsEndYear',
    'totalCashValueEndYear',
    'paidUpAdditionsEndYear',
    'totalDeathBenefitEndYear',
    'totalPaidUpInsuranceEndYear',
  ],
  Cash: [
    'policyYear',
    'ageEndYear',
    'guaranteedContractPremiumBegYear',
    'guaranteedCashValueEndYear',
    'guaranteedDeathBenefitEndYear',
    'contractPremiumBegYear',
    'dividendPaidInCashBegYear',
    'taxOnDistributionBegYear',
    'annualNetOutlayBegYear',
    'totalCashValueEndYear',
    'totalDeathBenefitEndYear',
    'totalPaidUpInsuranceEndYear',
  ],
  PRCash: [
    'policyYear',
    'ageEndYear',
    'guaranteedContractPremiumBegYear',
    'guaranteedCashValueEndYear',
    'guaranteedDeathBenefitEndYear',
    'contractPremiumBegYear',
    'netPremiumBegYear',
    'annualDividendEndYear',
    'dividendPaidInCashBegYear',
    'taxOnDistributionBegYear',
    'annualNetOutlayBegYear',
    'totalCashValueEndYear',
    'totalDeathBenefitEndYear',
    'totalPaidUpInsuranceEndYear',
  ],
  PRPUA: [
    'policyYear',
    'ageEndYear',
    'guaranteedContractPremiumBegYear',
    'guaranteedCashValueEndYear',
    'guaranteedDeathBenefitEndYear',
    'contractPremiumBegYear',
    'netPremiumBegYear',
    'annualDividendEndYear',
    'cashValueOfAdditionsEndYear',
    'totalCashValueEndYear',
    'paidUpAdditionsEndYear',
    'totalDeathBenefitEndYear',
    'totalPaidUpInsuranceEndYear',
  ],
  Accumulate: [
    'policyYear',
    'ageEndYear',
    'guaranteedContractPremiumBegYear',
    'guaranteedCashValueEndYear',
    'guaranteedDeathBenefitEndYear',
    'contractPremiumBegYear',
    'annualDividendEndYear',
    'taxOnDistributionBegYear',
    'annualNetOutlayBegYear',
    'cashValueOfAccumsEndYear',
    'totalCashValueEndYear',
    'totalDeathBenefitEndYear',
    'totalPaidUpInsuranceEndYear',
  ],
  Concept: [
    'policyYear',
    'ageEndYear',
    'annualOutlayBegYear',
    'annualLoan',
    'withdrawAmount',
    'annualNetOutlayBegYear',
    'annualDividendEndYear',
    'guaranteedCashValueEndYear',
    'cashValueOfAdditionsEndYear',
    'totalOutstandingLoanEndYear',
    'netCashValueEndYear',
    'totalPaidUpInsuranceEndYear',
    'netDeathBenefitEndYear',
  ],
};

export const ColumnHeaderDefWithRtrMap = {
  Cash: `<TR>
            <TH><P>&nbsp;</P></TH>
            <TH><P>&nbsp;</P></TH>
            <TH ><P>&nbsp;</P></TH>
            <TH><P>&nbsp;</P></TH>
            <TH><P>&nbsp;</P></TH>
            <Th colspan=7 class="td-underline" align="center"><P class="p-center"><NOBR>Non-Guaranteed</NOBR> Values*</P></Th>
        </TR>
        <TR class="illustration-header-row">
            <TH><P>&nbsp;</P></TH>
            <TH><P>&nbsp;</P></TH>
            <TH><P>&nbsp;</P></TH>
            <TH><P>Guaranteed</P></TH>
            <TH><P>Guaranteed</P></TH>
            <TH><P>&nbsp;</P></TH>
            <TH><P>Dividend</P></TH>
            <TH><P>&nbsp;</P></TH>
            <TH><P>Annual</P></TH>
            <TH><P>Total</P></TH>
            <TH><P>Total</P></TH>
            <TH><P>Total</P></TH>
        </TR>
        <TR class="illustration-header-row">
            <TH><P>&nbsp;</P></TH>
            <TH><P>Age</P></TH>
            <TH><P>Contract</P></TH>
            <TH><P>Cash</P></TH>
            <TH><P>Death</P></TH>
            <TH><P>&nbsp;</P></TH>
            <TH><P>Paid in</P></TH>
            <TH><P>Tax on</P></TH>
            <TH><P>Net</P></TH>
            <TH><P>Cash</P></TH>
            <TH><P>Death</P></TH>
            <TH><P><NOBR>Paid-Up</NOBR></P></TH>
        </TR>
        <TR class="illustration-header-row">
            <TH><P>&nbsp;</P></TH>
            <TH><P>End</P></TH>
            <TH><P>Premium for</P></TH>
            <TH><P>Value</P></TH>
            <TH><P>Benefit</P></TH>
            <TH><P>Contract</P></TH>
            <TH><P>Cash</P></TH>
            <TH><P>Distribution</P></TH>
            <TH><P>Outlay</P></TH>
            <TH><P>Value</P></TH>
            <TH><P>Benefit</P></TH>
            <TH><P>Insurance</P></TH>
        </TR>
        <TR class="td-underline illustration-header-row">
            <TH><P>Year</P></TH>
            <TH><P>Year</P></TH>
            <TH><P>Gtd Values</P></TH>
            <TH><P>End Year</P></TH>
            <TH><P>End Year</P></TH>
            <TH><P>Premium</P></TH>
            <TH><P>Beg Year</P></TH>
            <TH><P>Beg Year</P></TH>
            <TH><P>Beg Year</P></TH>
            <TH><P>End Year</P></TH>
            <TH><P>End Year</P></TH>
            <TH><P>End Year</P></TH>
        </TR>`,
  PRPUA: `<TR>
            <TH><P>&nbsp;</P></TH>
            <TH><P>&nbsp;</P></TH>
            <TH ><P>&nbsp;</P></TH>
            <TH><P>&nbsp;</P></TH>
            <TH><P>&nbsp;</P></TH>
            <Th colspan=8 class="td-underline"><P class="p-center"><NOBR>Non-Guaranteed</NOBR> Values*</P></Th>
        </TR>
        <TR class="illustration-header-row">
            <TH><P>&nbsp;</P></TH>
            <TH><P>&nbsp;</P></TH>
            <TH><P>&nbsp;</P></TH>
            <TH><P>Guaranteed</P></TH>
            <TH><P>Guaranteed</P></TH>
            <TH><P>&nbsp;</P></TH>
            <TH><P>&nbsp;</P></TH>
            <TH><P>&nbsp;</P></TH>
            <TH><P>Cash</P></TH>
            <TH><P>Total</P></TH>
            <TH><P>&nbsp;</P></TH>
            <TH><P>Total</P></TH>
            <TH><P>Total</P></TH>
        </TR>
        <TR class="illustration-header-row">
            <TH><P>&nbsp;</P></TH>
            <TH><P>Age</P></TH>
            <TH><P>Contract</P></TH>
            <TH><P>Cash</P></TH>
            <TH><P>Death</P></TH>
            <TH><P>&nbsp;</P></TH>
            <TH><P>Net</P></TH>
            <TH><P>Annual</P></TH>
            <TH><P>Value of</P></TH>
            <TH><P>Cash</P></TH>
            <TH><P><NOBR>Paid-Up</NOBR></P></TH>
            <TH><P>Death</P></TH>
            <TH><P><NOBR>Paid-Up</NOBR></P></TH>
        </TR>
        <TR class="illustration-header-row">
            <TH><P>&nbsp;</P></TH>
            <TH><P>End</P></TH>
            <TH><P>Premium for</P></TH>
            <TH><P>Value</P></TH>
            <TH><P>Benefit</P></TH>
            <TH><P>Contract</P></TH>
            <TH><P>Premium</P></TH>
            <TH><P>Dividend</P></TH>
            <TH><P>Additions</P></TH>
            <TH><P>Value</P></TH>
            <TH><P>Additions</P></TH>
            <TH><P>Benefit</P></TH>
            <TH><P>Insurance</P></TH>
        </TR>
        <TR class="td-underline illustration-header-row">
            <TH><p>Year</P></TH>
            <TH><p>Year</P></TH>
            <TH><p>Gtd Values</P></TH>
            <TH><p>End Year</P></TH>
            <TH><p>End Year</P></TH>
            <TH><P>Premium</P></TH>
            <TH><p>Beg Year</P></TH>
            <TH><p>End Year</P></TH>
            <TH><p>End Year</P></TH>
            <TH><p>End Year</P></TH>
            <TH><p>End Year</P></TH>
            <TH><p>End Year</P></TH>
            <TH><p>End Year</P></TH>
        </TR>`,
  PRCash: `<TR class="illustration-header-row">
            <TH><P>&nbsp;</P></TH>
            <TH><P>&nbsp;</P></TH>
            <TH><P>&nbsp;</P></TH>
            <TH><P>&nbsp;</P></TH>
            <TH><P>&nbsp;</P></TH>
            <Th colspan=9 class="td-underline"><P class="p-center"><NOBR>Non-Guaranteed</NOBR> Values*</P></Th>
        </TR>
        <TR class="illustration-header-row">
            <TH><P>&nbsp;</P></TH>
            <TH><P>&nbsp;</P></TH>
            <TH><P>&nbsp;</P></TH>
            <TH><P>Guaranteed</P></TH>
            <TH><P>Guaranteed</P></TH>
            <TH><P>&nbsp;</P></TH>
            <TH><P>&nbsp;</P></TH>
            <TH><P>&nbsp;</P></TH>
            <TH><P>Dividend</P></TH>
            <TH><P>&nbsp;</P></TH>
            <TH><P>Annual</P></TH>
            <TH><P>Total</P></TH>
            <TH><P>Total</P></TH>
            <TH><P>Total</P></TH>
        </TR>
        <TR class="illustration-header-row">
            <TH><P>&nbsp;</P></TH>
            <TH><P>Age</P></TH>
            <TH><P>Contract</P></TH>
            <TH><P>Cash</P></TH>
            <TH><P>Death</P></TH>
            <TH><P>&nbsp;</P></TH>
            <TH><P>Net</P></TH>
            <TH><P>Annual</P></TH>
            <TH><P>Paid in</P></TH>
            <TH><P>Tax on</P></TH>
            <TH><P>Net</P></TH>
            <TH><P>Cash</P></TH>
            <TH><P>Death</P></TH>
            <TH><P><NOBR>Paid-up</NOBR></P></TH>
        </TR>
        <TR class="illustration-header-row">
            <TH><P>&nbsp;</P></TH>
            <TH><P>End</P></TH>
            <TH><P>Premium for</P></TH>
            <TH><P>Value</P></TH>
            <TH><P>Benefit</P></TH>
            <TH><P>Contract</P></TH>
            <TH><P>Premium</P></TH>
            <TH><P>Dividend</P></TH>
            <TH><P>Cash</P></TH>
            <TH><P>Distribution</P></TH>
            <TH><P>Outlay</P></TH>
            <TH><P>Value</P></TH>
            <TH><P>Benefit</P></TH>
            <TH><P>Insurance</P></TH>
        </TR>
        <TR class="td-underline illustration-header-row">
            <TH><p>Year</P></TH>
            <TH><p>Year</P></TH>
            <TH><p>Gtd Values</P></TH>
            <TH><p>End Year</P></TH>
            <TH><p>End Year</P></TH>
            <TH><P>Premium</P></TH>
            <TH><p>Beg Year</P></TH>
            <TH><p>End Year</P></TH>
            <TH><p>Beg Year</P></TH>
            <TH><p>Beg Year</P></TH>
            <TH><p>Beg Year</P></TH>
            <TH><p>End Year</P></TH>
            <TH><P>End Year</P></TH>
            <TH><P>End Year</P></TH>
        </TR>`,
  Accumulate: `<TR>
            <TH><P>&nbsp;</P></TH>
            <TH><P>&nbsp;</P></TH>
            <TH><P>&nbsp;</P></TH>
            <TH><P>&nbsp;</P></TH>
            <TH><P>&nbsp;</P></TH>
            <Th colspan=8 class="td-underline"><P class="p-center"><NOBR>Non-Guaranteed</NOBR> Values*</P></Th>
        </TR>
        <TR class="illustration-header-row">
            <TH><P>&nbsp;</P></TH>
            <TH><P>&nbsp;</P></TH>
            <TH><P>&nbsp;</P></TH>
            <TH><P>Guaranteed</P></TH>
            <TH><P>Guaranteed</P></TH>
            <TH><P>&nbsp;</P></TH>
            <TH><P>&nbsp;</P></TH>
            <TH><P>&nbsp;</P></TH>
            <TH><P>Annual</P></TH>
            <TH><P>Cash</P></TH>
            <TH><P>Total</P></TH>
            <TH><P>Total</P></TH>
            <TH><P>Total</P></TH>

        </TR>
        <TR class="illustration-header-row">
            <TH><P>&nbsp;</P></TH>
            <TH><P>Age</P></TH>
            <TH><P>Contract</P></TH>
            <TH><P>Cash</P></TH>
            <TH><P>Death</P></TH>
            <TH><P>&nbsp;</P></TH>
            <TH><P>Annual</P></TH>
            <TH><P>Tax on</P></TH>
            <TH><P>Net</P></TH>
            <TH><P>Value of</P></TH>
            <TH><P>Cash</P></TH>
            <TH><P>Death</P></TH>
            <TH><P><NOBR>Paid-Up</NOBR></P></TH>
        </TR>
        <TR class="illustration-header-row">
            <TH><P>&nbsp;</P></TH>
            <TH><P>End</P></TH>
            <TH><P>Premium for</P></TH>
            <TH><P>Value</P></TH>
            <TH><P>Benefit</P></TH>
            <TH><P>Contract</P></TH>
            <TH><P>Dividend</P></TH>
            <TH><P>Distribution</P></TH>
            <TH><P>Outlay</P></TH>
            <TH><P>Accums</P></TH>
            <TH><P>Value</P></TH>
            <TH><P>Benefit</P></TH>
            <TH><P>Insurance</P></TH>
        </TR>
        <TR class="td-underline illustration-header-row">
            <TH><P>Year</P></TH>
            <TH><P>Year</P></TH>
            <TH><P>Gtd Values</P></TH>
            <TH><P>End Year</P></TH>
            <TH><P>End Year</P></TH>
            <TH><P>Premium</P></TH>
            <TH><P>End Year</P></TH>
            <TH><P>End Year</P></TH>
            <TH><P>Beg Year</P></TH>
            <TH><P>Beg Year</P></TH>
            <TH><P>End Year</P></TH>
            <TH><P>End Year</P></TH>
            <TH><P>End Year</P></TH>
        </TR>`,
  PUA: `<TR>
            <TH><P>&nbsp;</P></TH>
            <TH><P>&nbsp;</P></TH>
            <TH ><P>&nbsp;</P></TH>
            <TH><P>&nbsp;</P></TH>
            <TH><P>&nbsp;</P></TH>
            <Th colspan=7 class="td-underline"><P class="p-center"><NOBR>Non-Guaranteed</NOBR> Values*</P></Th>
        </TR>
        <TR class="illustration-header-row">
            <TH><P>&nbsp;</P></TH>
            <TH><P>&nbsp;</P></TH>
            <TH><P>Contract</P></TH>
            <TH><P>Guaranteed</P></TH>
            <TH><P>Guaranteed</P></TH>
            <TH><P>&nbsp;</P></TH>
            <TH><P>&nbsp;</P></TH>
            <TH><P>Cash</P></TH>
            <TH><P>Total</P></TH>
            <TH><P>&nbsp;</P></TH>
            <TH><P>Total</P></TH>
            <TH><P>Total</P></TH>
        </TR>
        <TR class="illustration-header-row">
            <TH><P>&nbsp;</P></TH>
            <TH><P>Age</P></TH>
            <TH><P>Premium for</P></TH>
            <TH><P>Cash</P></TH>
            <TH><P>Death</P></TH>
            <TH><P>&nbsp;</P></TH>
            <TH><P >Annual</P></TH>
            <TH><P>Value of</P></TH>
            <TH><P>Cash</P></TH>
            <TH><P><NOBR>Paid-Up</NOBR></P></TH>
            <TH><P>Death</P></TH>
            <TH><P><NOBR>Paid-Up</NOBR></P></TH>
        </TR>
        <TR class="illustration-header-row">
            <TH><P>&nbsp;</P></TH>
            <TH><P>End</P></TH>
            <TH><P>Gtd Values</P></TH>
            <TH><P>Value</P></TH>
            <TH><P>Benefit</P></TH>
            <TH><P>Contract</P></TH>
            <TH><P>Dividend</P></TH>
            <TH><P>Additions</P></TH>
            <TH><P>Value</P></TH>
            <TH><P>Additions</P></TH>
            <TH><P>Benefit</P></TH>
            <TH><P>Insurance</P></TH>
        </TR>
        <TR class="td-underline illustration-header-row">
            <TH><P>Year</P></TH>
            <TH><P>Year</P></TH>
            <TH><P>Beg Year</P></TH>
            <TH><P>End Year</P></TH>
            <TH><P>End Year</P></TH>
            <TH><P>Premium</P></TH>
            <TH><P>End Year</P></TH>
            <TH><P>End Year</P></TH>
            <TH><P>End Year</P></TH>
            <TH><P>End Year</P></TH>
            <TH><P>End Year</P></TH>
            <TH><P>End Year</P></TH>
        </TR>`,
  Concept: `<TR>
                <TH><P>&nbsp;</P></TH>
                <TH><P>&nbsp;</P></TH>
                <Th colspan=11 class="td-underline"><P class="p-center"><NOBR>Non-Guaranteed</NOBR> Values*</P></Th>
              </TR>
              <TR class="illustration-header-row">
                <TH><P>&nbsp;</P></TH>
                <TH><P>&nbsp;</P></TH>
                <TH><P>&nbsp;</P></TH>
                <TH><P>&nbsp;</P></TH>
                <TH><P>&nbsp;</P></TH>
                <TH><P>&nbsp;</P></TH>
                <TH><P>&nbsp;</P></TH>
                <TH><P>Basic</P></TH>
                <TH><P>Total Cash</P></TH>
                <TH><P>Total</P></TH>
                <TH><P>Net</P></TH>
                <TH><P>Total</P></TH>
                <TH><P>Net</P></TH>
              </TR>
              <TR class="illustration-header-row">
                <TH><P>&nbsp;</P></TH>
                <TH><P>Age</P></TH>
                <TH><P>&nbsp;</P></TH>
                <TH><P>&nbsp;</P></TH>
                <TH><P>&nbsp;</P></TH>
                <TH><P>Annual</P></TH>
                <TH><P>Annual</P></TH>
                <TH><P>Policy</P></TH>
                <TH><P>Value of</P></TH>
                <TH><P>Outstanding</P></TH>
                <TH><P>Cash</P></TH>
                <TH><P><NOBR>Paid-Up</NOBR></P></TH>
                <TH><P>Death</P></TH>
              </TR>
              <TR class="illustration-header-row">
                <TH><P>&nbsp;</P></TH>
                <TH><P>End</P></TH>
                <TH><P>Annual</P></TH>
                <TH><P>Annual</P></TH>
                <TH><P>Annual</P></TH>
                <TH><P>Net</P></TH>
                <TH><P>Dividend</P></TH>
                <TH><P>Cash Value</P></TH>
                <TH><P>Additions</P></TH>
                <TH><P>Loan</P></TH>
                <TH><P>Value</P></TH>
                <TH><P>Additions</P></TH>
                <TH><P>Benefit</P></TH>
              </TR>
              <TR class="td-underline illustration-header-row">
                <TH><P>Year</P></TH>
                <TH><P>Year</P></TH>
                <TH><P>Outlay</P></TH>
                <TH><P>Loan</P></TH>
                <TH><P>Surrender</P></TH>
                <TH><P>Outlay</P></TH>
                <TH><P>End Year</P></TH>
                <TH><P>End Year</P></TH>
                <TH><P>End Year</P></TH>
                <TH><P>End Year</P></TH>
                <TH><P>End Year</P></TH>
                <TH><P>End Year</P></TH>
                <TH><P>End Year</P></TH>
              </TR>`,
};
